import { apiSlice } from "./apiSlice";

export const contractManagementDashBoardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getContractManagementChangeOrder: builder.query({
            query: (params) => ({
                url: `Change/analytics`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ChangeDashbaord"],
        }),
        getContractManagementAgeingAnalysis: builder.query({
            query: (params) => ({
                url: `Change/ageing-analysis`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ChangeDashbaord"],
        }),
        getContractManagementValuePercentage: builder.query({
            query: (params) => ({
                url: `Change/value-percentage/${params.projectId}`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ChangeDashbaord"],
        }),
        getContractManagementCountByStatus: builder.query({
            query: (params) => ({
                url: `Change/count-by-status`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ChangeDashbaord"],
        }),
        getContractManagementClaimOrder: builder.query({
            query: (params) => ({
                url: `Claim/analytics`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClaimDashbaord"],
        }),
        getContractManagementClaimAgeingAnalysis: builder.query({
            query: (params) => ({
                url: `Claim/ageing-analysis`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClaimDashbaord"],
        }),
        getContractManagementClaimValuePercentage: builder.query({
            query: (params) => ({
                url: `Claim/value-percentage/${params.projectId}`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClaimDashbaord"],
        }),
        getContractManagementClaimCountByStatus: builder.query({
            query: (params) => ({
                url: `Claim/count-by-status`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClaimDashbaord"],
        }),

        // Important KPI
        getContractManagementImportantKPI: builder.query({
            query: (params) => ({
                url: `ContractManagement`,
                params

            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClaimDashbaord"],
        }),
    }),
});

export const {
    useGetContractManagementAgeingAnalysisQuery,
    useGetContractManagementChangeOrderQuery,
    useGetContractManagementCountByStatusQuery,
    useGetContractManagementValuePercentageQuery,
    useGetContractManagementClaimCountByStatusQuery,
    useGetContractManagementClaimOrderQuery,
    useGetContractManagementClaimValuePercentageQuery,
    useGetContractManagementClaimAgeingAnalysisQuery,
    useGetContractManagementImportantKPIQuery
} = contractManagementDashBoardSlice;